import { render } from "./VerificationItemSite.vue?vue&type=template&id=1dfd6864"
import script from "./VerificationItemSite.vue?vue&type=script&lang=js"
export * from "./VerificationItemSite.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__